import React, { useState } from 'react';

import {
  Box,
  Divider,
  Stepper,
  Step,
  StepButton,
  StepLabel,
  Typography,
  lighten,
  Color,
} from '@mui/material';

import { MutationStatus } from '@tanstack/react-query';

import FormPaper from './FormPaper';
import SaveButton from './SaveButton';

export interface IStep {
  id: number,
  name: string,
  hasError: boolean,
}
interface IFormStepperBanner {
  color: Color;
  reportedBy: string;
  title: string;
  onSave?: () => void;
  isDirty?: boolean;
  saveStatus?: MutationStatus;
  lastSaved?: string | null;
  enableAutoSave?: boolean;
  hideSave?: boolean;
  onStepChange: (step: number) => void;
  activeStep: number;
  stepValues: IStep[];
  isSticky?: boolean;
  reportedByVerbage?: string;
}

function FormStepperBanner({
  color,
  reportedBy,
  title,
  onSave,
  isDirty,
  saveStatus,
  lastSaved,
  enableAutoSave,
  hideSave,
  onStepChange,
  activeStep,
  stepValues,
  isSticky,
  reportedByVerbage = 'Reported By',
}: IFormStepperBanner): JSX.Element {
  const handleSave = () => {
    if (onSave) {
      onSave();
    }
  };
  const handleStepChange = (id: number) => () => onStepChange(id);
  const [isBannerSticky, setIsBannerSticky] = useState(isSticky ?? true);
  return (
    <Box sx={{ position: `${isBannerSticky ? 'sticky' : 'relative'}`, zIndex: 10, top: 0 }}>
      <FormPaper color={color}>
        <Box display="flex" alignItems="center" sx={{ mx: 2, my: 1 }}>
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="caption">{`${reportedByVerbage}: ${reportedBy}`}</Typography>
          </Box>
          <Box>
            <SaveButton
              enableAutoSave={enableAutoSave}
              lastSaved={lastSaved}
              saveStatus={saveStatus}
              isDirty={isDirty}
              onSave={handleSave}
              isHidden={hideSave}
            />
          </Box>
        </Box>
        <Divider />
        <Stepper
          alternativeLabel
          nonLinear
          activeStep={activeStep}
          sx={{ my: 3, mx: 1, backgroundColor: lighten(color[200], 0.8) }}
        >
          {stepValues.map((value) => (
            <Step key={value.id}>
              <StepButton onClick={handleStepChange(value.id)}>
                <StepLabel error={value.hasError}>
                  {value.name}
                </StepLabel>
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </FormPaper>
    </Box>
  );
}

export default FormStepperBanner;
